import { Tag } from 'antd'
import styled from 'styled-components'

const StyledTag = styled(Tag)`
  padding: 4px 8px;
`
export { StyledTag }
